import React, { useState } from "react";
import styles from "./BillsAttachments.module.css";
import { Button, DownloadIcon } from "evergreen-ui";

export const BillsAttachments = ({ documents }) => {
  const [show, setShow] = useState(true);

  const handleDownload = (urls) => {
    let url = urls;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/attachment.svg" alt="" />
            </div>
            <h6>Attachments</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show && styles.rotateSvg}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <div className="basicDetailsDivRfqColumDiv columnImpRfq">
            <div>
              {/* <p></p>
                        <div>img1</div>
                        <p></p>
                        <p></p>
                        <div>img2</div> */}
              {documents &&
                documents.map((item) => {
                  return (
                    <>
                      <p></p>
                      <div className="imageLabelId">
                        {item.orig_name.slice(0, 20)}...
                      </div>
                    </>
                  );
                })}
            </div>
            <div>
              {documents &&
                documents.map((item) => {
                  return (
                    <>
                      <p></p>
                      <Button
                        className="downloadBtn"
                        height={32}
                        width={110}
                        iconBefore={DownloadIcon}
                        onClick={() => handleDownload(item?.file_download_url)}
                      >
                        Download
                      </Button>
                    </>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
